import { StockStatusEnum } from '@petsmart-ui/sparky';

import type { DeliveryType } from '@libs/core';

import { StockErrorItem } from '../types';
import { CartValidationErrorKey } from './notificationMaps';
import { shouldTreatInsufficientStockAsOutOfStock } from './stockStatus';

export const getStockStatusBasedOnError = (payload: {
    itemId: string;
    fulfillmentMethod: DeliveryType;
    defaultStockStatus: StockStatusEnum;
    stockErrors: StockErrorItem[];
    caseQty?: number;
}) => {
    const { itemId, fulfillmentMethod, defaultStockStatus, stockErrors, caseQty = 1 } = payload;

    const stockError = stockErrors?.find(
        error =>
            error.lineItemId === itemId && error.fulfillmentMethod.toLowerCase() === fulfillmentMethod.toLowerCase()
    );

    if (!stockError) {
        return defaultStockStatus;
    }

    switch (stockError.errorCode) {
        case CartValidationErrorKey.INSUFFICIENT_STOCK:
            return shouldTreatInsufficientStockAsOutOfStock(caseQty, stockError.available)
                ? StockStatusEnum.OutOfStock
                : StockStatusEnum.FewLeftInStock;
        case CartValidationErrorKey.OUT_OF_STOCK:
            return StockStatusEnum.OutOfStock;
        default:
            return defaultStockStatus;
    }
};
